import React from 'react';
import { TextField, Button, Box, Typography, CircularProgress, MenuItem } from '@mui/material';
import { motion } from 'framer-motion';
import countryCodes from './country-codes-list';

const Step1 = ({
  onNext, loading,
  onNameFocus = () => {},
  onEmailFocus = () => {},
  onPhoneFocus = () => {},
  onGradeFocus = () => {},
  onPasswordFocus = () => {},
  onConfirmFocus = () => {},
}) => {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState({ countryCode: '', number: '' });
  const [grade, setGrade] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    onNext({ name, email, phone: `${phone.countryCode}${phone.number}`, password, grade });
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <form onSubmit={handleSubmit}>
        <Typography variant="h6" gutterBottom>
          Basic Information
        </Typography>

        <TextField
          label="Full Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onFocus={onNameFocus}
          fullWidth
          margin="normal"
          required
        />

        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={onEmailFocus}
          fullWidth
          margin="normal"
          required
        />

        <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
          <TextField
            select
            label="Country Code"
            value={phone.countryCode}
            onChange={(e) => setPhone({ ...phone, countryCode: e.target.value })}
            onFocus={onPhoneFocus}
            sx={{ width: '30%', mr: 2 }}
            required
          >
            {Object.entries(countryCodes)
              .sort((a, b) => a[1].name.localeCompare(b[1].name))
              .map(([code, { name, phoneCode }]) => (
                <MenuItem key={code} value={phoneCode}>
                  {name} ({phoneCode})
                </MenuItem>
              ))}
          </TextField>

          <TextField
            label="Whatsapp Number"
            value={phone.number}
            onChange={(e) => setPhone({ ...phone, number: e.target.value })}
            onFocus={onPhoneFocus}
            fullWidth
            required
          />
        </Box>

        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          Grade
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 2 }}>
          <Button
            variant={grade === '1' ? 'contained' : 'outlined'}
            onClick={() => { setGrade('1'); onGradeFocus(); }}
            fullWidth
            sx={{ mx: 1 }}
          >
            12-13 Years
            Grade 7-8
          </Button>
          <Button
            variant={grade === '2' ? 'contained' : 'outlined'}
            onClick={() => { setGrade('2'); onGradeFocus(); }}
            fullWidth
            sx={{ mx: 1 }}
          >
            14-15 Years
            Grade 9-10
          </Button>
          <Button
            variant={grade === '3' ? 'contained' : 'outlined'}
            onClick={() => { setGrade('3'); onGradeFocus(); }}
            fullWidth
            sx={{ mx: 1 }}
          >
            16-17 Years
            Grade 11-12
          </Button>
        </Box>

        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          Password
        </Typography>

        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onFocus={onPasswordFocus}
          fullWidth
          margin="normal"
          required
        />

        <TextField
          label="Confirm Password"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          onFocus={onConfirmFocus}
          fullWidth
          margin="normal"
          required
        />

        <Box sx={{ mt: 2 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Next'}
          </Button>
        </Box>
      </form>
    </motion.div>
  );
};

export default Step1;
